import {
  Badge,
  createTheme,
  Grid,
  ThemeProvider,
  Typography,
  useTheme
} from '@mui/material'
import React from 'react'

import { colors } from 'mui-theme/theme'

export const TutorialStep: React.FC<{
  title: string
  badgeNumber: number
}> = ({ title, badgeNumber, children, ...rest }) => {
  const theme = useTheme()

  // TODO remove this when the main muitheme is in place
  const newTheme = createTheme({
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        ...theme.palette.primary,
        main: colors.primary['650']
      },
      secondary: {
        main: colors.secondary.blue['600']
      },
      // used by <Button color="buttonPrimary" ... /> to get regular buttons instead of purple ones
      // @ts-ignore necessary for now and can't modify PaletteOptions
      buttonPrimary: {
        ...theme.palette.primary
      }
    }
  })

  return (
    <ThemeProvider theme={newTheme}>
      <Grid container direction="row" ml={1} mt={2} spacing={2} {...rest}>
        <Grid item mt={0.3}>
          <Badge badgeContent={badgeNumber} color="primary" />
        </Grid>
        <Grid item xs={11}>
          <Typography color="primary" variant="h6">
            {title}
          </Typography>
          {children}
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}
